export default {
  admin: [
    {
      icon: 'fa fa-wrench',
      label: 'module.system.config',
      group: [
        {
          label: 'page.site.config',
          route: {
            name: 'admin.config.site',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          label: '前台設定',
          route: {
            name: 'admin.config.public-site',
          },
          roles: ['ROLE_ADMIN'],
        },
        {
          label: 'page.tracker.config',
          route: {
            name: 'admin.config.tracker',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          label: 'page.config.language',
          route: {
            name: 'admin.config.language',
          },
          roles: ['ROLE_MAINTAINER'],
          create: (getRestrict, isMaintainer) => {
            if(isMaintainer) return true
            return !!getRestrict('i18n.status')
          },
        },
        {
          label: 'page.text.config',
          route: {
            name: 'admin.config.text',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          label: 'page.text',
          route: {
            name: 'admin.text',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          label: 'page.sitemap',
          route: {
            name: 'admin.config.sitemap',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          label: 'page.oauth.config',
          route: {
            name: 'admin.config.oauth',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          label: 'page.etc.config',
          route: {
            name: 'admin.config.etc',
          },
          roles: ['ROLE_MAINTAINER'],
        },
      ],
    },
    {
      icon: 'fa fa-bell',
      label: 'feature.notification.config',
      group: [
        {
          label: 'page.mail.config',
          route: {
            name: 'admin.config.mail',
          },
          roles: ['ROLE_MAINTAINER'],
          create: (getRestrict) => !!getRestrict('notification.mail'),
        },
        {
          label: 'page.line_notify.config',
          route: {
            name: 'admin.config.line_notify',
          },
          roles: ['ROLE_MAINTAINER'],
          create: (getRestrict) => !!getRestrict('notification.line_notify'),
        },
        {
          label: 'page.slack.config',
          route: {
            name: 'admin.config.slack',
          },
          roles: ['ROLE_MAINTAINER'],
          create: (getRestrict) => !!getRestrict('notification.slack'),
        },
      ],
    },

    {
      icon: 'fa fa-bug',
      label: 'Debug',
      group: [
        {
          label: '影片設定',
          route: {
            name: 'admin.debug-video',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          label: 'GA報表設定',
          route: {
            name: 'admin.debug-ga-report',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        // {
        //   label: 'Broadcast',
        //   route: {
        //     name: 'admin.debug-broadcast',
        //   },
        //   roles: ['ROLE_MAINTAINER'],
        // },
        // {
        //   label: 'Notification',
        //   route: {
        //     name: 'admin.debug-notification',
        //   },
        //   roles: ['ROLE_MAINTAINER'],
        // },
        // {
        //   label: 'File permission',
        //   route: {
        //     name: 'admin.debug-permission',
        //   },
        //   roles: ['ROLE_MAINTAINER'],
        // },
      ],
    },
  ],
}